export default __webpack_public_path__ + "static/media/rightarrow.e7475329.svg";